import { render, staticRenderFns } from "./SelectedVideosFooter.vue?vue&type=template&id=55ee7625"
import script from "./SelectedVideosFooter.vue?vue&type=script&lang=js"
export * from "./SelectedVideosFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports